import { type ChangeEvent, useCallback, useEffect } from 'react'
import { MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SelectV2 from '../../Common/Form/SelectV2'
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch'
import { useAppSelector } from '../../Common/_hooks/useAppSelector'
import { SaveUserPrefs } from '../../UserData/_actions/UserDataActions'

type Props = {
  label: string
  value: number
  onChange: (value: number) => void
}

export default function AccountLimitFilter(props: Props) {
  const dispatch = useAppDispatch()
  const [t] = useTranslation('common')
  const userLimit = useAppSelector(state => state.get('userData').get('prefs').get('accountPageLimit'))

  useEffect(() => {
    if (props.value === userLimit) {
      return
    }

    const fd = new FormData()
    fd.append('accountPageLimit', String(props.value))
    dispatch(SaveUserPrefs(fd, true))
  }, [dispatch, props.value, userLimit])

  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(Number(e.target.value))
  }, [props.onChange])

  return <SelectV2
    label={props.label}
    value={props.value}
    onChange={onChange}
  >
    <MenuItem value={20}>{t('{{count}} per page', { count: 20 })}</MenuItem>
    <MenuItem value={50}>{t('{{count}} per page', { count: 50 })}</MenuItem>
    <MenuItem value={100}>{t('{{count}} per page', { count: 100 })}</MenuItem>
  </SelectV2>
}
